function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M20 38.5C9.799 38.5 1.5 30.201 1.5 20C1.5 9.799 9.799 1.5 20 1.5C30.201 1.5 38.5 9.799 38.5 20C38.5 30.201 30.201 38.5 20 38.5Z",
  fill: "#233780",
  fillOpacity: 0.12
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M20 2C29.925 2 38 10.075 38 20C38 29.925 29.925 38 20 38C10.075 38 2 29.925 2 20C2 10.075 10.075 2 20 2ZM20 1C9.507 1 1 9.507 1 20C1 30.493 9.507 39 20 39C30.493 39 39 30.493 39 20C39 9.507 30.493 1 20 1Z",
  fill: "#233780"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M20 14C21.1046 14 22 13.1046 22 12C22 10.8954 21.1046 10 20 10C18.8954 10 18 10.8954 18 12C18 13.1046 18.8954 14 20 14Z",
  fill: "#233780"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M22 28V16H17V17H18V28H17V29H23V28H22Z",
  fill: "#233780"
});

var SvgCircleInfo = function SvgCircleInfo(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCircleInfo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/circleInfo.e5213ef3.svg";
export { ForwardRef as ReactComponent };